import { render, staticRenderFns } from "./HotelResult.vue?vue&type=template&id=733fae74"
import script from "./HotelResult.vue?vue&type=script&lang=js"
export * from "./HotelResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingRating: require('/vercel/path0/components/partials/BookingRating.vue').default,Rating: require('/vercel/path0/components/partials/Rating.vue').default,Favorite: require('/vercel/path0/components/partials/Favorite.vue').default,Stars: require('/vercel/path0/components/partials/Stars.vue').default,Currency: require('/vercel/path0/components/partials/Currency.vue').default})
